import { jsxs as ie, jsx as l } from "react/jsx-runtime";
import { c as he } from "react/compiler-runtime";
import { TableBody as ae, TableRow as X, TableCell as O, Skeleton as de, CircularProgress as me, Box as ce, Typography as xe, Checkbox as pe, IconButton as be } from "@mui/material";
import { flexRender as we } from "@tanstack/react-table";
import { getHeaderWidths as Ce, getGroupDetails as ye, createDragGhost as Re } from "./utils.js";
import Se from "@mui/icons-material/KeyboardArrowDown";
import { u as ue } from "../../../chunks/TableContext.js";
import { styles as a } from "./styles.js";
import { useVirtualizer as De } from "@tanstack/react-virtual";
import { useRef as Ee, useState as We, useEffect as ve, useMemo as Be } from "react";
import { DragIndicator as ke } from "@mui/icons-material";
function je() {
  const {
    table: d,
    isGroupable: e,
    emptyStateComponent: t,
    isLoading: w,
    enableVirtualization: g,
    isDraggable: f,
    enableSelection: D,
    groupByColumns: m = [],
    columnSizing: v
  } = ue(), x = d.getRowModel().rows, u = Ee(null), [h, F] = We({});
  ve(() => {
    if (g) {
      const r = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const o = Ce(d);
          F(o);
        });
      });
      return () => cancelAnimationFrame(r);
    }
  }, [d, g, v]);
  const y = Be(() => {
    if (g) {
      const o = {};
      return d.getAllColumns().forEach((n) => {
        if (n.id !== "expander" && !n.getIsGrouped()) {
          const i = n.columnDef, c = h[n.id], C = v[n.id];
          o[n.id] = c ?? C ?? i.width ?? "auto";
        }
      }), o;
    }
    const r = {};
    return d.getAllColumns().forEach((o) => {
      if (o.id !== "expander" && !o.getIsGrouped()) {
        const n = o.columnDef, i = v[o.id];
        r[o.id] = i ?? n.width ?? "auto";
      }
    }), r;
  }, [d, g, v, h]), p = De({
    count: x.length,
    getScrollElement: () => {
      if (u.current) {
        if (!u.current.closest('.MuiDialog-container, .MuiDialogContent-root, [role="dialog"], dialog')) {
          const i = document.getElementById("table-container");
          return i || document.body;
        }
        let n = u.current.parentElement;
        for (; n && n !== document.body; ) {
          const i = window.getComputedStyle(n), c = i.overflow === "auto" || i.overflow === "scroll" || i.overflowY === "auto" || i.overflowY === "scroll", C = n.scrollHeight > n.clientHeight, R = i.height !== "auto" && i.height !== "", b = i.maxHeight !== "none" && i.maxHeight !== "";
          if (c && (C || R || b))
            return n;
          n = n.parentElement;
        }
      }
      const r = document.getElementById("table-container");
      return r || document.body;
    },
    estimateSize: () => 52,
    // Initial estimate, will be updated by dynamic measurement
    overscan: 5,
    measureElement: (r) => r?.getBoundingClientRect().height || 52,
    enabled: g
  });
  if (w) {
    const r = d.getAllColumns().filter((n) => n.id !== "expander" && !m?.includes(n.id)), o = [];
    return D && o.push("selection"), f && o.push("drag"), o.push(...r.map((n) => n.id)), /* @__PURE__ */ ie(ae, { sx: a.tableBody, ref: u, children: [
      Array.from({
        length: 5
      }).map((n, i) => /* @__PURE__ */ l(X, { sx: a.tableRow, children: o.map((c) => {
        if (c === "selection")
          return /* @__PURE__ */ l(O, { sx: {
            ...a.tableCell,
            borderBottom: "1px solid #EFEFEF",
            width: 48,
            maxWidth: 48,
            minWidth: 48,
            padding: "12px 16px"
          }, children: /* @__PURE__ */ l(de, { variant: "rectangular", width: 16, height: 16 }) }, `skeleton-cell-selection-${i}`);
        if (c === "drag")
          return /* @__PURE__ */ l(O, { sx: {
            ...a.tableCell,
            borderBottom: "1px solid #EFEFEF",
            width: 32,
            maxWidth: 32,
            minWidth: 32,
            padding: "12px 16px"
          }, children: /* @__PURE__ */ l(de, { width: 10, height: 20 }) }, `skeleton-cell-drag-${i}`);
        const R = r.find((B) => B.id === c)?.columnDef, b = y[c] || R?.width;
        return /* @__PURE__ */ l(O, { sx: {
          ...a.tableCell,
          borderBottom: "1px solid #EFEFEF",
          width: b,
          maxWidth: b,
          minWidth: b,
          padding: "12px 16px"
        }, children: /* @__PURE__ */ l(de, { variant: "rectangular", width: i % 2 === 1 ? "50%" : "70%", height: 12, sx: {
          borderRadius: 12
        } }) }, `skeleton-cell-${i}-${c}`);
      }) }, `skeleton-row-${i}`)),
      /* @__PURE__ */ l(X, { children: /* @__PURE__ */ l(O, { colSpan: o.length, sx: {
        border: "none",
        textAlign: "left",
        padding: "16px"
      }, children: /* @__PURE__ */ l(me, { size: 22, thickness: 5, sx: a.defaultLoadingSpinner }) }) })
    ] });
  }
  if (x.length === 0) {
    const r = f && D ? d.getAllColumns().length + 2 : f || D ? d.getAllColumns().length + 3 : d.getAllColumns().length;
    return /* @__PURE__ */ l(ae, { sx: a.tableBody, ref: u, children: /* @__PURE__ */ l(X, { children: /* @__PURE__ */ l(O, { colSpan: r, sx: a.emptyStateCell, children: t || "No data" }) }) });
  }
  if (g) {
    const r = D && f ? d.getAllColumns().length + 2 : D || f ? d.getAllColumns().length + 1 : d.getAllColumns().length;
    return /* @__PURE__ */ l(ae, { sx: {
      ...a.tableBody,
      ...a.virtualizedTableBody,
      width: "max-content",
      minWidth: "100%"
    }, ref: u, children: /* @__PURE__ */ l(X, { sx: {
      height: `${p.getTotalSize()}px`,
      position: "relative",
      width: "max-content",
      minWidth: "100%"
    }, children: /* @__PURE__ */ l(O, { colSpan: r, sx: {
      height: "100%",
      padding: 0,
      border: "none",
      position: "relative",
      width: "max-content",
      minWidth: "100%"
    }, children: p.getVirtualItems().map((o) => {
      const n = x[o.index];
      if (!n) return null;
      const i = {
        position: "absolute",
        top: `${o.start}px`,
        left: 0,
        width: "max-content",
        minWidth: "100%"
      };
      return e && n.getIsGrouped() ? /* @__PURE__ */ l(X, { "data-index": o.index, ref: (c) => p.measureElement(c), style: i, children: /* @__PURE__ */ l(ge, { row: n, enableVirtualization: g, headerWidths: y }) }, o.key) : /* @__PURE__ */ l(X, { "data-index": o.index, ref: (c) => p.measureElement(c), style: i, component: g ? "div" : "tr", children: /* @__PURE__ */ l(fe, { row: n, isLastRow: o.index === x.length - 1, enableVirtualization: g, headerWidths: y }) }, o.key);
    }) }) }) });
  }
  return /* @__PURE__ */ l(ae, { sx: a.tableBody, children: x.map((r, o) => {
    const n = o === x.length - 1;
    return e && r.getIsGrouped() ? /* @__PURE__ */ l(ge, { row: r, enableVirtualization: g, headerWidths: y }, r.id) : /* @__PURE__ */ l(fe, { row: r, isLastRow: n, enableVirtualization: g, headerWidths: y }, r.id);
  }) });
}
function ge(d) {
  const e = he(82), {
    row: t,
    style: w,
    enableVirtualization: g,
    headerWidths: f
  } = d, {
    table: D,
    expanded: m,
    getColumnById: v,
    handleRowRightClick: x,
    rowSx: u,
    handleRowEnter: h,
    handleRowLeave: F
  } = ue(), y = m === !0 || !!m?.[t.id];
  let p, r, o, n, i, c, C, R, b, B, L, k, z, J, S, V;
  if (e[0] !== g || e[1] !== v || e[2] !== h || e[3] !== F || e[4] !== x || e[5] !== f || e[6] !== y || e[7] !== t || e[8] !== u || e[9] !== w || e[10] !== D) {
    R = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        nestingLevel: $,
        groupValue: Z,
        groupByColumn: ee
      } = ye(t), q = v(ee), te = q?.groupRenderer !== void 0, H = q?.hideGroupingValues?.(t) ?? !1, ne = q?.hideGroupingRow?.(t) ?? !1;
      let G, I;
      if (e[27] !== g || e[28] !== f || e[29] !== D) {
        I = D.getAllLeafColumns().filter(Fe);
        let W;
        e[32] !== g || e[33] !== f ? (W = (oe, le) => {
          const re = le.columnDef, se = g && f[le.id] || re.width;
          return oe + (typeof se == "number" ? se : 0);
        }, e[32] = g, e[33] = f, e[34] = W) : W = e[34], G = I.reduce(W, 0), e[27] = g, e[28] = f, e[29] = D, e[30] = G, e[31] = I;
      } else
        G = e[30], I = e[31];
      const Y = G;
      if (ne) {
        t.toggleExpanded(!0), R = null;
        break e;
      }
      o = X;
      let N;
      e[35] !== w ? (N = w || {}, e[35] = w, e[36] = N) : N = e[36];
      let K;
      e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (K = {
        backgroundColor: "#ffffff"
      }, e[37] = K) : K = e[37];
      let A;
      e[38] !== t || e[39] !== u ? (A = typeof u == "function" ? u(t.original) : u, e[38] = t, e[39] = u, e[40] = A) : A = e[40], e[41] !== N || e[42] !== A ? (S = {
        ...a.tableRow,
        ...N,
        ":hover": K,
        ...A
      }, e[41] = N, e[42] = A, e[43] = S) : S = e[43], V = "row", e[44] !== x || e[45] !== t ? (i = (W) => {
        W.preventDefault(), x?.(W, t.original, t.index);
      }, e[44] = x, e[45] = t, e[46] = i) : i = e[46], e[47] !== h || e[48] !== t ? (c = (W) => h?.(W, t.original, t.index), e[47] = h, e[48] = t, e[49] = c) : c = e[49], e[50] !== F || e[51] !== t ? (C = (W) => F?.(W, t.original, t.index), e[50] = F, e[51] = t, e[52] = C) : C = e[52], r = O, L = "left", e[53] !== Y ? (k = {
        ...a.groupedRow,
        width: Y,
        minWidth: Y,
        maxWidth: Y,
        boxSizing: "border-box",
        height: "auto"
      }, e[53] = Y, e[54] = k) : k = e[54], z = I.length, J = "cell", p = ce;
      const _ = `${$ * 30}px`;
      e[55] !== _ ? (n = {
        ...a.groupedRowContent,
        paddingLeft: _
      }, e[55] = _, e[56] = n) : n = e[56];
      const P = y ? "rotate(180deg)" : "rotate(0deg)", Q = H ? "not-allowed" : "pointer", U = H ? 0.5 : 1;
      let s;
      e[57] !== P || e[58] !== Q || e[59] !== U ? (s = {
        ...a.expandButton,
        transform: P,
        cursor: Q,
        opacity: U
      }, e[57] = P, e[58] = Q, e[59] = U, e[60] = s) : s = e[60];
      let E;
      e[61] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (E = /* @__PURE__ */ l(Se, {}), e[61] = E) : E = e[61], b = /* @__PURE__ */ l(be, { onClick: () => !H && t.toggleExpanded(), size: "small", sx: s, children: E }), B = te ? q?.groupRenderer?.({
        row: t,
        groupValue: Z,
        subRows: t.subRows,
        subRowsCount: t.subRows.length,
        toggleExpanded: () => !H && t.toggleExpanded(),
        isExpanded: y,
        nestingLevel: $,
        columnId: ee
      }) : /* @__PURE__ */ ie(ce, { sx: {
        display: "flex",
        alignItems: "center"
      }, children: [
        Z,
        !H && /* @__PURE__ */ ie(xe, { variant: "body2", sx: {
          ml: 1
        }, children: [
          "(",
          t.subRows.length,
          ")"
        ] })
      ] });
    }
    e[0] = g, e[1] = v, e[2] = h, e[3] = F, e[4] = x, e[5] = f, e[6] = y, e[7] = t, e[8] = u, e[9] = w, e[10] = D, e[11] = p, e[12] = r, e[13] = o, e[14] = n, e[15] = i, e[16] = c, e[17] = C, e[18] = R, e[19] = b, e[20] = B, e[21] = L, e[22] = k, e[23] = z, e[24] = J, e[25] = S, e[26] = V;
  } else
    p = e[11], r = e[12], o = e[13], n = e[14], i = e[15], c = e[16], C = e[17], R = e[18], b = e[19], B = e[20], L = e[21], k = e[22], z = e[23], J = e[24], S = e[25], V = e[26];
  if (R !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return R;
  let M;
  e[62] !== p || e[63] !== n || e[64] !== b || e[65] !== B ? (M = /* @__PURE__ */ ie(p, { sx: n, children: [
    b,
    B
  ] }), e[62] = p, e[63] = n, e[64] = b, e[65] = B, e[66] = M) : M = e[66];
  let T;
  e[67] !== r || e[68] !== M || e[69] !== L || e[70] !== k || e[71] !== z || e[72] !== J ? (T = /* @__PURE__ */ l(r, { align: L, sx: k, colSpan: z, role: J, children: M }), e[67] = r, e[68] = M, e[69] = L, e[70] = k, e[71] = z, e[72] = J, e[73] = T) : T = e[73];
  let j;
  return e[74] !== o || e[75] !== i || e[76] !== c || e[77] !== C || e[78] !== T || e[79] !== S || e[80] !== V ? (j = /* @__PURE__ */ l(o, { sx: S, role: V, onContextMenu: i, onMouseEnter: c, onMouseLeave: C, children: T }), e[74] = o, e[75] = i, e[76] = c, e[77] = C, e[78] = T, e[79] = S, e[80] = V, e[81] = j) : j = e[81], j;
}
function Fe(d) {
  return d.id !== "expander" && !d.getIsGrouped();
}
function fe(d) {
  const e = he(91), {
    row: t,
    isLastRow: w,
    style: g,
    enableVirtualization: f,
    headerWidths: D
  } = d, {
    enableSelection: m,
    toggleRowSelection: v,
    isRowSelected: x,
    selectedRows: u,
    isDraggable: h,
    onDragStart: F,
    onDragEnd: y,
    dragLabelColumnId: p,
    dragCountSuffix: r,
    handleRowClick: o,
    handleRowRightClick: n,
    rowSx: i,
    selectedRowIndex: c,
    onRowClick: C,
    handleRowEnter: R,
    handleRowLeave: b,
    isRowSelectionDisabled: B,
    selectedRowId: L
  } = ue(), k = r === void 0 ? "Items" : r;
  let z;
  if (e[0] !== k || e[1] !== p || e[2] !== m || e[3] !== f || e[4] !== o || e[5] !== R || e[6] !== b || e[7] !== n || e[8] !== D || e[9] !== h || e[10] !== w || e[11] !== x || e[12] !== B || e[13] !== y || e[14] !== F || e[15] !== C || e[16] !== t || e[17] !== i || e[18] !== L || e[19] !== c || e[20] !== u || e[21] !== g || e[22] !== v) {
    const J = t.getVisibleCells().filter(Ie);
    let S, V;
    e[24] !== m || e[25] !== x || e[26] !== t.original ? (S = m ? JSON.stringify(t.original) : "", V = m ? x(S) : !1, e[24] = m, e[25] = x, e[26] = t.original, e[27] = S, e[28] = V) : (S = e[27], V = e[28]);
    const M = V;
    let T;
    e[29] !== B || e[30] !== t.index || e[31] !== t.original ? (T = B?.(t.original, t.index) ?? !1, e[29] = B, e[30] = t.index, e[31] = t.original, e[32] = T) : T = e[32];
    const j = T;
    let $;
    if (e[33] !== p || e[34] !== t) {
      if ($ = "Moving", p) {
        const s = t.getVisibleCells().find((E) => E.column.id === p)?.getValue();
        s !== void 0 && ($ = `${s}`);
      }
      e[33] = p, e[34] = t, e[35] = $;
    } else
      $ = e[35];
    let Z;
    e[36] !== k || e[37] !== h || e[38] !== $ || e[39] !== F || e[40] !== t.original || e[41] !== u ? (Z = (s) => {
      if (h) {
        const E = u.size > 0 ? Array.from(u).map(Ae) : [t.original];
        s.dataTransfer.setData("application/json", JSON.stringify(E)), Re(s, $, u.size, k), F?.(s, E);
      }
    }, e[36] = k, e[37] = h, e[38] = $, e[39] = F, e[40] = t.original, e[41] = u, e[42] = Z) : Z = e[42];
    let ee;
    e[43] !== h || e[44] !== y || e[45] !== t.original || e[46] !== u ? (ee = (s) => {
      if (h) {
        const E = u.size > 0 ? Array.from(u).map(Le) : [t.original];
        y?.(s, E);
      }
    }, e[43] = h, e[44] = y, e[45] = t.original, e[46] = u, e[47] = ee) : ee = e[47];
    let q;
    e[48] !== o || e[49] !== t.index || e[50] !== t.original ? (q = (s) => o?.(s, t.original, t.index, t.original.id), e[48] = o, e[49] = t.index, e[50] = t.original, e[51] = q) : q = e[51];
    let te;
    e[52] !== n || e[53] !== t.index || e[54] !== t.original ? (te = (s) => {
      s.preventDefault(), n?.(s, t.original, t.index);
    }, e[52] = n, e[53] = t.index, e[54] = t.original, e[55] = te) : te = e[55];
    let H;
    e[56] !== R || e[57] !== t.index || e[58] !== t.original ? (H = (s) => R?.(s, t.original, t.index), e[56] = R, e[57] = t.index, e[58] = t.original, e[59] = H) : H = e[59];
    let ne;
    e[60] !== b || e[61] !== t.index || e[62] !== t.original ? (ne = (s) => b?.(s, t.original, t.index), e[60] = b, e[61] = t.index, e[62] = t.original, e[63] = ne) : ne = e[63];
    let G;
    e[64] !== g ? (G = g || {}, e[64] = g, e[65] = G) : G = e[65];
    let I;
    e[66] !== f ? (I = f ? {
      display: "flex",
      width: "max-content",
      minWidth: "100%"
    } : {}, e[66] = f, e[67] = I) : I = e[67];
    const Y = C ? "pointer" : "default", N = L && L === t.original.id || c === t.index ? "#e5f3f0" : "#ffffff", K = L && L === t.original.id || c === t.index ? "#e5f3f0" : "#F8F8F8";
    let A;
    e[68] !== K ? (A = {
      backgroundColor: K
    }, e[68] = K, e[69] = A) : A = e[69];
    let _;
    e[70] !== t.original || e[71] !== i ? (_ = typeof i == "function" ? i(t.original) : i, e[70] = t.original, e[71] = i, e[72] = _) : _ = e[72];
    let P;
    e[73] !== G || e[74] !== I || e[75] !== Y || e[76] !== N || e[77] !== A || e[78] !== _ ? (P = {
      ...a.tableRow,
      ...G,
      ...I,
      cursor: Y,
      backgroundColor: N,
      ":hover": A,
      ..._
    }, e[73] = G, e[74] = I, e[75] = Y, e[76] = N, e[77] = A, e[78] = _, e[79] = P) : P = e[79];
    let Q;
    e[80] !== m || e[81] !== j || e[82] !== w || e[83] !== M || e[84] !== S || e[85] !== v ? (Q = m && /* @__PURE__ */ l(O, { sx: {
      ...a.tableCell,
      ...a.bodySelectionCell,
      borderBottom: w ? "none" : "1px solid #EFEFEF"
    }, children: /* @__PURE__ */ l(pe, { checked: M, disabled: j, onChange: () => !j && v(S), sx: a.checkbox }) }), e[80] = m, e[81] = j, e[82] = w, e[83] = M, e[84] = S, e[85] = v, e[86] = Q) : Q = e[86];
    let U;
    e[87] !== m || e[88] !== h || e[89] !== w ? (U = h && /* @__PURE__ */ l(O, { sx: {
      ...a.tableCell,
      ...a.bodyDragCell,
      ...m ? {} : a.bodyDragCellNoSelection,
      ...w ? a.bodyCellLastRow : {}
    }, children: /* @__PURE__ */ l(ce, { sx: a.dragIndicatorContainer, children: /* @__PURE__ */ l(ke, { sx: a.dragIndicator }) }) }), e[87] = m, e[88] = h, e[89] = w, e[90] = U) : U = e[90], z = /* @__PURE__ */ ie(X, { component: f ? "div" : "tr", draggable: h, onDragStart: Z, onDragEnd: ee, onClick: q, onContextMenu: te, onMouseEnter: H, onMouseLeave: ne, sx: P, role: "row", children: [
      Q,
      U,
      t.getVisibleCells().map((s) => {
        const E = s.column.columnDef, W = D[s.column.id] ?? E.width ?? "auto", oe = J.findIndex((se) => se.column.id === s.column.id), le = oe === 0, re = oe === J.length - 1;
        return s.column.id !== "expander" && !s.column.getIsGrouped() && /* @__PURE__ */ l(O, { component: f ? "div" : "td", align: "left", sx: {
          ...a.tableCell,
          ...a.bodyCell,
          width: W,
          maxWidth: E.maxWidth || W,
          minWidth: E.minWidth || W,
          ...f ? {
            flex: "0 0 auto"
          } : {},
          ...le && !m && !h ? a.bodyCellFirst : {},
          ...re ? a.bodyCellLast : {},
          ...w ? a.bodyCellLastRow : {}
        }, role: "cell", children: we(s.column.columnDef.cell, s.getContext()) }, s.id);
      })
    ] }), e[0] = k, e[1] = p, e[2] = m, e[3] = f, e[4] = o, e[5] = R, e[6] = b, e[7] = n, e[8] = D, e[9] = h, e[10] = w, e[11] = x, e[12] = B, e[13] = y, e[14] = F, e[15] = C, e[16] = t, e[17] = i, e[18] = L, e[19] = c, e[20] = u, e[21] = g, e[22] = v, e[23] = z;
  } else
    z = e[23];
  return z;
}
function Le(d) {
  return JSON.parse(d);
}
function Ae(d) {
  return JSON.parse(d);
}
function Ie(d) {
  return d.column.id !== "expander" && !d.column.getIsGrouped();
}
export {
  je as TableBody
};
